import React from 'react';
import styled from 'styled-components';
import { T } from '../../../shared/helpers';
import MdReportProblem from '../../../shared/icons/exclamation-triangle-solid.svg';
import { ContainerBase } from '../../widgets/layouts';
import { Icon } from '../../widgets/icon';
import { Link } from '../../widgets/buttons';

const Container = styled(ContainerBase)`
    max-width: 600px;
    padding-top: 30px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 160px;

    ${Icon} {
        width: 128px;
        height: 128px;
    }
`;

const NotFoundPage = () => (
    <Container>
        <Icon>
            <MdReportProblem />
        </Icon>
        <h2>{T._('Page not found :(', 'Admin')}</h2>
        <p>
            {T._('Please contact us at:', 'Admin')} <Link href='mailto:help@zakeke.com'>help@zakeke.com</Link>
        </p>
    </Container>
);

export default NotFoundPage;
